/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * WhatsApp message types.
 *
 * Defines all supported message types that can be received from WhatsApp webhooks,
 * including standard message types and special types for coexistence features.
 */
export enum WhatsAppMessageType {
    TEXT = 'text',
    IMAGE = 'image',
    AUDIO = 'audio',
    VIDEO = 'video',
    DOCUMENT = 'document',
    STICKER = 'sticker',
    LOCATION = 'location',
    CONTACTS = 'contacts',
    INTERACTIVE = 'interactive',
    REACTION = 'reaction',
    BUTTON = 'button',
    ORDER = 'order',
    SYSTEM = 'system',
    UNKNOWN = 'unknown',
    UNSUPPORTED = 'unsupported',
    MEDIA_PLACEHOLDER = 'media_placeholder',
}
